import { render } from "./UserLayout.vue?vue&type=template&id=0385080e&scoped=true"
const script = {}

import "./UserLayout.vue?vue&type=style&index=0&id=0385080e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0385080e"]])

export default __exports__